import { defaultIconColor } from './constants';
import { SVGComponentPropsType } from './types';

const defaultSize = 24;

export default ({ size = defaultSize, color = defaultIconColor, ...props }: SVGComponentPropsType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
    {...props}
  >
    <g transform="translate(3 6)" fill="none" fillRule="evenodd">
      <rect stroke={color} strokeWidth="2" x="1" y="1" width="16" height="10" rx="1" />
      <path fill={color} d="M13 3h2v2h-2zM13 7h2v2h-2zM3 3h2v2H3zM3 7h2v2H3z" />
    </g>
  </svg>
);
